import { Input } from '@components/core-ui/form-elements/Input';
import { AdminGetOrganizationResponseDto } from 'app/API';
import { OrganizationImageViewOnly } from '../OrganizationImage';
import { InputBlockWrapper } from './styles/InputBlockWrapper';
import { InputWrapper } from './styles/InputWrapper';
import { LeftSide } from './styles/LeftSide';
import { RightSide } from './styles/RightSide';
import { RightSideColumns } from './styles/RightSideColumns';
import { Wrapper } from './styles/Wrapper';

type TProps = {
  organization: AdminGetOrganizationResponseDto;
};

export const NameSectionViewOnly = ({ organization }: TProps) => {
  return (
    <div>
      <Wrapper>
        <LeftSide>
          <h3>General</h3>
        </LeftSide>

        <RightSide>
          <OrganizationImageViewOnly org={organization} />
          <RightSideColumns>
            <InputBlockWrapper>
              <InputWrapper>
                <label htmlFor="name">Organization name</label>
                <Input
                  className="form-input w-full"
                  disabled={true}
                  onChange={() => {}}
                  name="slug"
                  value={organization.name}
                  label="Organization name"
                />
              </InputWrapper>

              <InputWrapper>
                <label htmlFor="slug">Organization URL</label>
                <Input
                  className="form-input w-full"
                  disabled={true}
                  onChange={() => {}}
                  name="slug"
                  value={organization.slug}
                  label="Organization URL"
                />
              </InputWrapper>
            </InputBlockWrapper>
          </RightSideColumns>
        </RightSide>
      </Wrapper>
    </div>
  );
};
